import { isDefined } from '@sgme/fp';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { filter, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import type { EpicWithThunk } from 'state/state.common';
import { hasBatchTabContent } from 'state/workspaces/batch/tabContent/tabContent.selectors';
import type { WorkspaceType } from 'state/workspaces/model';
import { workspaceTabContentFetchRequested } from 'state/workspaces/tabContent/tabContent.actions';
import { isTabLoadable } from 'state/workspaces/tabs/tabs.model';
import { getWorkspaceTab } from 'state/workspaces/tabs/tabs.selector';

function isWorkspaceWithTabContentPersistance(workspace: WorkspaceType): boolean {
  switch (workspace) {
    case 'ordersBasket':
      return false;
    default:
      return true;
  }
}

// TODO catch Error in Epic
export function fetchTabContentOnTabActivatedEpic(): EpicWithThunk {
  return (actions$, state$) =>
    actions$.pipe(
      ofType('WORKSPACE_TAB_ACTIVATED'),
      withLatestFrom(state$),
      filter(([action, state]) => !hasBatchTabContent(state, action.tabId)),
      map(([action, state]) => getWorkspaceTab(state, action.tabId)),
      filter(isDefined),
      filter(tab => isWorkspaceWithTabContentPersistance(tab.workspace) && isTabLoadable(tab.loadingStatus)),
      mergeMap(tab => of(workspaceTabContentFetchRequested(tab.id, tab.workspace, tab.type))),
    );
}
